import { Component, Input, OnInit } from '@angular/core';
import { Dossier, General, Fe, Adm, Actions, Eval, Connaissances, Langue, Adresse, Diplome, Remarques } from '../entities/dossier';
import { AuthService } from '../auth.service';
import { GenericService } from '../generic.service';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, FormControl} from '@angular/forms';
import { NotificationService } from '../notification.service';


@Component({
  selector: 'app-fiche-entretien',
  templateUrl: './fiche-entretien.component.html',
  styleUrls: ['./fiche-entretien.component.css']
})
export class FicheEntretienComponent implements OnInit, OnDestroy {

  form: FormGroup;
  public showSpinner : boolean = false;
  public query: string;
  //public errorMessage: string;
  //public successMessage: string;
  public dossier : Dossier;
  public general : General;
  public fe : Fe;
  public actions: Actions;
  public remarques: Remarques;
  public connaissances: Connaissances;
  public adm : Adm;
  public eval : Eval;
  public evals :   Eval[] = [];
  public justCreated : String;

  //public firtNameManager;
  //public managers : any[] = [];

  public justSaved  : String;
  //public MsgError  : String;

  //afficher par défaut le prénom du Manager connecté dans la liste déroulante
  public defaultManager : string;

  constructor(private _authService: AuthService,  private _genericService: GenericService, 
    private _router : Router, private _notifyService: NotificationService ) { }

  ngOnInit() {
    this._authService.checkCredentials();
    this.dossier = new Dossier();
    this.general = new General();
    this.fe = new Fe();
    this.connaissances = new Connaissances();
    this.adm = new Adm();
    this.actions = new Actions();
    this.remarques = new Remarques();
    this.eval = new Eval();
    this.evals.push(this.eval);
    // init select tags
    this.general.permis = "";
    this.remarques.prendNotes = "";
    this.remarques.retard = "";
    this.remarques.visiteWeb = "";
    // prénom du manager connecté
    this.defaultManager = this._authService.getAuthenticatedFirstName();
    //this.clearMessages();
  }

  ngOnDestroy() {
    //this.clearMessages();
  }


  //Formatage des dates
  formatDateForDisplay(date){
    if(date != undefined)
      return date.substr(0,10);
  }

  // Enregistrer le dossier
  save(isValid){
    //this.clearMessages();
    if(isValid){

      this.dossier.general = this.general;
      this.dossier.general.nom = this.dossier.general.nom.trim().replace(/-/g, " ")
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ')
      .toUpperCase();

      let prenom = this.dossier.general.prenom.trim().replace(/-/g, ' ')
      .replace(/á|à|â|ä|a̧|ǎ|ã/gi,"a").replace(/ć|c̀|ĉ|c̈|ç|č|c̃/gi,"c")
      .replace(/é|è|ê|ë|ȩ|ě|ẽ/gi,"e").replace(/í|ì|î|ï|i̧|ǐ|ĩ/gi,"i")
      .replace(/ó|ò|ô|ö|o̧|ǒ|õ/gi, "o").replace(/ú|ù|û|ü|u̧|ǔ|ũ/gi,"u").replace(/  +/g, ' ').split(' ');

      let pp="";
      for(let i=0 ; i < prenom.length ; i++ ) {
        let lettreUn = prenom[i][0].toUpperCase();
        let resteMot = prenom[i].substring(1).toLowerCase();
        pp= pp + lettreUn + resteMot+' ';
      }

      this.dossier.general.prenom = pp.trim();

      this.dossier.general.email =  this.dossier.general.email.trim().toLowerCase();
      this.dossier.general.nom.replace('-', ' ');
      this.fe.adm = this.adm;
      this.fe.actions = this.actions;
      this.fe.connaissances = this.connaissances;
      this.fe.remarques = this.remarques;
      this.evals[0].manager =  this.defaultManager.trim();
      this.actions.evals = this.evals;
      this.dossier.fe = this.fe;

      this.dossier.general.dateDernierEntretien = this.dossier.fe.actions.evals[0].date;

      // creation d'un nouveau dossier
      this.showSpinner = true;
      this._genericService.saveResource(environment.createDossier, this.dossier, true, environment.contentTypes.json)
        .subscribe(
          data => {
            //window.scrollTo(0, 0),
            //this.successMessage = 'Dossier crée avec succès',
            this._notifyService.showSuccess("Dossier crée avec succès", "Create folder", 3000)
            //window.scrollTo(0, 0),
            this.justSaved = data._id,
            data.general.dateDernierEntretien = this.dossier.fe.actions.evals[0].date.toISOString().substr(0,10);

            this._router.navigate(['/dossierDetails'], {queryParams : { id : data._id}});
          },
          error => {
            this.showSpinner = false;
            this._notifyService.showError("Le candiat existe déjà", "Create folder", 2000)
            //window.scrollTo(0, 0),
            /*this.errorMessage = "Le candiat existe déjà !";
            this.MsgError = error.message;
            setTimeout(()=>{
              this.MsgError = '';
            }, 2000);*/
          }
          );
    }else{
      this._notifyService.showError("Champs requis non rempli", "Create folder", 2000)
      /*window.scrollTo(0, 0);
      this.errorMessage = "Champs requis non rempli";
      this.MsgError = this.errorMessage;
      setTimeout(()=>{
        this.MsgError = '';
      }, 2000);*/

    }
  }

  // Réinitialiser les messages d'erreur et de succès
  /*clearMessages(){
    this.successMessage = '';
    this.errorMessage = '';
  }*/


  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    }
    return null;
}

affiche(dateEval){
}

}



// WEBPACK FOOTER //
// ./src/app/fiche-entretien/fiche-entretien.component.ts